import { render, staticRenderFns } from "./HeaderDropdownNotif.vue?vue&type=template&id=053cc2fe&"
import script from "./HeaderDropdownNotif.vue?vue&type=script&lang=js&"
export * from "./HeaderDropdownNotif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports